<!--首页-->
<template>
	<div class="main">
		<div class="activity-content">
			<div class="activity-tip">
				好友获得助力即可
				<span>免费畅玩</span>
			</div>
			<div class="zlbtn" @click="zlFunction">
				<img src="/static/images/forfree/money.png" />
				帮TA助力
			</div>
			<div class="linkbtn">
				<a href="http://m.xubei.com">
					<img src="/static/images/forfree/home.png" />
					<em>返回首页</em>
				</a>
				<a href="http://m.xubei.com/#/goodslist?gameId=1494&gameName=%E7%BB%9D%E5%9C%B0%E6%B1%82%E7%94%9F&gameType=1">
					<img src="/static/images/forfree/fb.png" />
					<em>我要租号</em>
				</a>
			</div>
		</div>
		<div class="pageModal" v-show="isShowCon">
			<div class="title">
				提示
				<img src="/static/images/forfree/close.png" @click="closeModal" />
			</div>
			<div class="page-cont" v-show="iscont">
				<div class="t1">
					<img src="/static/images/forfree/icon.png" />
					<span>助力成功</span>
					<img src="/static/images/forfree/icon.png" />
				</div>
				<div class="t2">您已经成功帮好友助力,棒棒哒！</div>
			</div>
			<div class="page-cont" v-show="!iscont">
				<div class="t2" v-html="cont">每天只能帮好友助力一次哦~</div>
			</div>
		</div>
		<div class="mask" v-show="isMask"></div>
	</div>
</template>

<script>
import { PROXY_URL } from '../../../config/env';
import { getQueryCode } from '../../../service/getData';
export default {
	name: 'wifisp',
	components: {},
	data: function () {
		return {
			activInitiatorId: this.$route.query.activInitiatorId || '96',
			isMask: false,
			isShowCon: false,
			iscont: false, //提示内容
			cont: ''
		};
	},
	mounted() {},
	methods: {
		zlFunction: function () {
			var self = this;

			this.ajax
				.get(PROXY_URL.service + '/anon/assist/isCanAssist?activInitiatorId=' + self.activInitiatorId)
				.then(res => {
					console.log(res);
					if (res.data.code == '1') {
						self.getZuli();
					} else {
						self.cont = res.data.message;
						self.isMask = true;
						self.isShowCon = true;
						self.iscont = false;
					}
				});
		},
		getZuli: function () {
			console.log(this);
			var self = this;
			getQueryCode().then(res => {
				if (res.data.code == '1') {
					var HEAD = document.getElementsByTagName('head').item(0) || document.documentElement;
					var script = document.createElement('script');
					script.setAttribute('type', 'text/javascript');
					script.setAttribute('src', res.data.result);
					HEAD.appendChild(script);

					script.onload = function () {
						var capOption = { callback: cbfn, type: 'popup' };
						capInit(document.getElementById('TCaptcha'), capOption);
						//回调函数：验证码页面关闭时回调
						self.isMask = true;
						function cbfn(retJson) {
							if (retJson.ret == 0) {
								// 用户验证成功
								console.log(retJson);
								self.isMask = false;

								let data = {
									ticket: retJson.ticket
								};

								self.ajax
									.get(
										PROXY_URL.service +
											'/anon/assist/addAssistor?activNo=' +
											PROXY_URL.activNo +
											'&activInitiatorId=' +
											self.activInitiatorId +
											'&ticket=' +
											data.ticket
									)
									.then(res => {
										console.log(res);
										if (res.data.code == '1') {
											self.isMask = true;
											self.isShowCon = true;
											self.iscont = true;
										} else {
											self.cont = res.data.message;
											self.isMask = true;
											self.isShowCon = true;
											self.iscont = false;
										}
									})
									.catch(error => {});

								capDestroy();
							} else {
								//用户关闭验证码页面，没有验证
								self.isMask = false;
								capDestroy();
							}
						}
					};
				} else {
					self.$toast(res.data.message);
				}
			});
		},
		closeModal: function () {
			this.isMask = false;
			this.isShowCon = false;
			this.iscont = false;
		}
	}
};
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
input::-webkit-input-placeholder {
	/* placeholder颜色  */
	color: #999;
}
.main {
	width: 100%;
	height: 100%;
	background: #472023;
}
.activity-content {
	width: px2rem(750rem);
	height: px2rem(1334rem);
	background: #472023 url(/static/images/forfree/bg.png) no-repeat;
	background-size: 100% 100%;
	padding-top: px2rem(371rem);
	margin: 0 auto;

	.activity-tip {
		width: px2rem(596rem);
		height: px2rem(80rem);
		line-height: px2rem(80rem);
		background: url(/static/images/forfree/bt.png) no-repeat;
		background-size: 100% 100%;
		text-align: center;
		font-size: px2rem(33rem);
		color: #ffffff;
		margin: 0 auto;
		span {
			color: #f8e71c;
		}
	}
	.zlbtn {
		width: px2rem(670rem);
		height: px2rem(98rem);
		line-height: px2rem(98rem);
		background: url(/static/images/forfree/btn.png) no-repeat;
		background-size: 100% 100%;
		margin: px2rem(277rem) auto 0 auto;
		text-align: center;
		font-size: px2rem(34rem);
		color: #ffffff;
		img {
			width: px2rem(83rem);
			height: px2rem(78rem);
			vertical-align: middle;
		}
	}

	.linkbtn {
		text-align: center;
		margin-top: px2rem(410rem);
		a {
			color: #fff;
			padding: 0 px2rem(25rem);
			font-size: px2rem(30rem);
			display: inline-block;
			img {
				width: px2rem(32rem);
				height: px2rem(32rem);
				vertical-align: middle;
				padding-right: px2rem(10rem);
			}
			em {
				vertical-align: middle;
				font-style: normal;
			}
		}
		a:first-child {
			border-right: 1px solid #cac7c7;
		}
	}
}
.pageModal {
	width: px2rem(560rem);
	position: absolute;
	left: 50%;
	top: 50%;
	z-index: 10;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	text-align: center;
	.title {
		width: 100%;
		height: px2rem(76rem);
		line-height: px2rem(76rem);
		background: url(/static/images/forfree/title.png) no-repeat;
		background-size: cover;
		font-size: px2rem(34rem);
		color: #fff;
		position: relative;
		img {
			width: px2rem(24rem);
			height: px2rem(24rem);
			position: absolute;
			right: px2rem(20rem);
			top: 50%;
			-webkit-transform: translate(0, -50%);
			-moz-transform: translate(0, -50%);
			transform: translate(0, -50%);
			padding: px2rem(10rem);
		}
	}
	.page-cont {
		background: #fff;
		padding: px2rem(66rem) px2rem(20rem) px2rem(149rem) px2rem(20rem);
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		.t1 {
			color: #333;
			font-size: px2rem(34rem);
			span {
				padding: 0 px2rem(20rem);
				vertical-align: middle;
			}
			img {
				width: px2rem(41rem);
				height: px2rem(41rem);
				vertical-align: middle;
			}
			img:first-child {
				transform: rotate(-90deg);
			}
		}
		.t2 {
			color: #666;
			font-size: px2rem(29rem);
			margin-top: px2rem(29rem);
		}
	}
}
.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	background: #000;
	opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/forfree/forfree.vue